

export default {
  name: 'GuestLayout',
  middleware: 'guest'
};
